import { createContext } from "react";

const AdminLeaveContext = createContext();

export default AdminLeaveContext;